import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicRoomArrangement({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M13 1.25c.97 0 1.75.78 1.75 1.75v10c0 .97-.78 1.75-1.75 1.75H3c-.97 0-1.75-.78-1.75-1.75V3c0-.97.78-1.75 1.75-1.75h10zm-7.75 5.5h-2.5V13c0 .14.11.25.25.25h2.25v-6.5zm8 0h-6.5v6.5H13c.14 0 .25-.11.25-.25V6.75zm-.25-4H3a.25.25 0 00-.25.25v2.25h10.5V3a.25.25 0 00-.25-.25z" />
    </svg>
  );
}

SvgBasicRoomArrangement.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicRoomArrangement.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicRoomArrangement svgRef={ref} {...props} />
));
export default ForwardRef;
